<template>
  <q-page :style-fn="myTweak">
    <div v-if="appStore.isInitialDataLoaded" class="q-pa-md">
      <skeleton-category :categoryCount="12" />
    </div>
    <div v-else-if="categoryStore.categories.length > 0">
      <Category :categories="categoryStore.categories" />
    </div>
    <div v-else>
      <div class="row justify-center">
        <q-spinner-dots color="primary" size="40px" />
      </div>
    </div>
  </q-page>
</template>

<script setup lang="ts">
import { onMounted } from "vue";
import { useRoute } from "vue-router";
import { Cookies } from "quasar";
import { AffiliateCodeKey, ExpireCookieDays } from "@/libs/constant";
import { addDateByDays } from "@/utils/dateUtil";
import { useCategoryStore } from "@/stores/categoryStore";
import { useAppStore } from "@/stores/appStore";
import { useSEOMeta } from "@/composables/useSEOMeta";
import Category from "@/components/card/Category.vue";
import SkeletonCategory from "@/components/skeleton/Category.vue";

const categoryStore = useCategoryStore();
const appStore = useAppStore();
const route = useRoute();

onMounted(async () => {
  appStore.setInitialDataLoaded(false);
  const affiliateCode = route.query.aff as string;
  if (affiliateCode) {
    Cookies.set(AffiliateCodeKey, affiliateCode, {
      expires: addDateByDays(ExpireCookieDays),
      path: "/",
      sameSite: "Strict"
    });
  }
});

const myTweak = (offset: number) => {
  return { minHeight: offset ? `calc(100vh - ${offset}px)` : "100vh" };
};

useSEOMeta({
  title: "Nail Supply Categories",
  description:
    "Browse nail supply categories and find the perfect products for your nail salon or personal use.",
  keywords:
    "Nail supply categories, Professional nail products, Nail tools, Beauty supplies",
  url: "/nail-supply/category",
  type: "website"
});
</script>
